/** Opaque 128-bit card id (base64url, 22 chars). Same as BFF DISCOUNT_CARD_CODE_PATTERN. */
export const CARD_CODE_PATTERN = /^[A-Za-z0-9_-]{22}$/;

export function isCardCode(value: string | undefined): value is string {
	return Boolean(value && CARD_CODE_PATTERN.test(value));
}
